import { isMainnet } from '@/composables/useNetwork';
import { Network } from '@balancer-labs/sdk';

export const MIN_FIAT_VALUE_POOL_MIGRATION = isMainnet.value ? 100_000 : 1; // 100K USD or $1 for other networks

export type FactoryType =
  | 'oracleWeightedPool'
  | 'weightedPool'
  | 'stablePool'
  | 'managedPool'
  | 'liquidityBootstrappingPool'
  | 'boostedPool';

export type Pools = {
  IdsMap: Partial<Record<Network, Record<'staBAL' | 'bbAaveUSD', string>>>;
  Pagination: {
    PerPage: number;
  };
  DelegateOwner: string;
  ZeroAddress: string;
  DynamicFees: {
    Gauntlet: string[];
  };
  BlockList: string[];
  ExcludedPoolTypes: string[];
  Stable: {
    AllowList: string[];
  };
  Investment: {
    AllowList: string[];
  };
  Factories: Record<string, FactoryType>;
};

export const POOLS: Pools = {
  IdsMap: {
    [Network.MAINNET]: {
      staBAL:
        '0x06df3b2bbb68adc8b0e302443692037ed9f91b42000000000000000000000063',
      bbAaveUSD:
        '0x7b50775383d3d6f0215a8f290f2c9e2eebbeceb20000000000000000000000fe'
    },
    [Network.KOVAN]: {
      staBAL:
        '0xd387dfd3a786e7caa06e6cf0c675352c7ffff30400000000000000000000063e',
      bbAaveUSD:
        '0x8fd162f338b770f7e879030830cde9173367f3010000000000000000000004d8'
    }
  },
  Pagination: {
    PerPage: 10
  },
  DelegateOwner: '0xba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1b',
  ZeroAddress: '0x0000000000000000000000000000000000000000',
  DynamicFees: {
    Gauntlet: [
      '0x8339e311265a025fd5792db800daa8eda4264e2c000200000000000000000029',
      '0x45910faff3cbf990fdb204682e93055506682d1700020000000000000000000d',
      '0xfa22ec1c02f121083bf04fbbcaad019f490d7a3000020000000000000000002a',
      '0xa660ba113f9aabaeb4bcd28a4a1705f4997d5432000200000000000000000022',
      '0xea8886a24b6e01fba88a9e98d794e8d1f29ed863000200000000000000000010',
      '0x0b09dea16768f0799065c475be02919503cb2a3500020000000000000000001a',
      '0xde148e6cc3f6047eed6e97238d341a2b8589e19e000200000000000000000017',
      '0x5d563ca1e2daaae3402c36097b934630ab53702c000200000000000000000024',
      '0x9f1f16b025f703ee985b58ced48daf93dad2f7ef00020000000000000000001e',
      '0x3ebf48cd7586d7a4521ce59e53d9a907ebf1480f000200000000000000000028',
      '0xefaa1604e82e1b3af8430b90192c1b9e8197e377000200000000000000000021',
      '0x9c08c7a7a89cfd671c79eacdc6f07c1996277ed5000200000000000000000025',
      '0xe99481dc77691d8e2456e5f3f61c1810adfc1503000200000000000000000018',
      '0xec60a5fef79a92c741cb74fdd6bfc340c0279b01000200000000000000000015',
      '0x231e687c9961d3a27e6e266ac5c433ce4f8253e4000200000000000000000023',
      '0x80be0c303d8ad2a280878b50a39b1ee8e54dbd2200020000000000000000000f',
      '0x5aa90c7362ea46b3cbfbd7f01ea5ca69c98fef1c000200000000000000000020',
      '0xa6f548df93de924d73be7d25dc02554c6bd66db500020000000000000000000e',
      '0x96646936b91d6b9d7d0c47c496afbf3d6ec7b6f8000200000000000000000019',
      '0x186084ff790c65088ba694df11758fae4943ee9e000200000000000000000013',
      '0x4626d81b3a1711beb79f4cecff2413886d461677000200000000000000000011',
      '0x072f14b85add63488ddad88f855fda4a99d6ac9b000200000000000000000027',
      '0xaac98ee71d4f8a156b6abaa6844cdb7789d086ce00020000000000000000001b',
      '0x7eb878107af0440f9e776f999ce053d277c8aca8000200000000000000000012',
      '0x16faf9f73748013155b7bc116a3008b57332d1e600020000000000000000001c',
      '0x6ae82385f76e3742f89cb46343b169f6ee49de1b000200000000000000000016',
      '0x8a92c3afabab59101b4e2426c82a7ddbb66b545000020000000000000000001f',
      '0x5c6ee304399dbdb9c8ef030ab642b10820db8f56000200000000000000000014',
      '0xf4c0dd9b82da36c07605df83c8a416f11724d88b000200000000000000000026',
      '0x3e5fa9518ea95c3e533eb377c001702a9aacaa32000200000000000000000052',
      '0xf8a0623ab66f985effc1c69d05f1af4badb01b0000020000000000000000001d',
      '0x021c343c6180f03ce9e48fae3ff432309b9af19900020000000000000000000b',
      '0x14462305d211c12a736986f4e8216e28c5ea7ab4000200000000000000000068',
      '0xf5aaf7ee8c39b651cebf5f1f50c10631e78e0ef9000200000000000000000069',
      '0xe2469f47ab58cf9cf59f9822e3c5de4950a41c49000200000000000000000089',
      '0xfeadd389a5c427952d8fdb8057d6c8ba1156cc56000000000000000000000066',
      '0x87165b659ba7746907a48763063efa3b323c2b0700020000000000000000002d',
      '0x06df3b2bbb68adc8b0e302443692037ed9f91b42000000000000000000000063'
    ]
  },
  BlockList: [''],
  ExcludedPoolTypes: ['Element', 'AaveLinear', 'Linear'],
  Stable: {
    AllowList: [
      '0x06df3b2bbb68adc8b0e302443692037ed9f91b42000000000000000000000063',
      '0xfeadd389a5c427952d8fdb8057d6c8ba1156cc56000000000000000000000066',
      '0x9f19a375709baf0e8e35c2c5c65aca676c4c719100000000000000000000006e',
      '0x49b823bec2d4e89cf4368bd743de1bc74871af22000000000000000000000006', // bsc - 3btc
      '0x292b9e9e1d2b3f30bfc06abd79a98f3e11665419000200000000000000000016', // bsc - renbtc-btc
      '0xa22f3e51939488962aa26d42799df75f72816ce0000000000000000000000007', // bsc - 4usd
      '0xbaca526c79b49a66f7f29123a2f4d7c17d08363600000000000000000000002e', // bsc - acsiBusdUsdcTusd
      '0xa56202a0f9be28fc091d80fa0b7ac20e5495b3bf00000000000000000000002f', // bsc - acsiBusdUsdtDaiMim
      '0xe901c4e9a56a175cb5c94bfb5f821ebd5fc826c500000000000000000000001d', // bsc - BUSD-USDT-TUSD-USTw-MIM
      '0xea20ac7b5e6379ceb44ab0e18c5e8a09da40eaa000020000000000000000000f', // bsc - tusd-busd
      '0x51441efb4beeb1694fcc985d522c12028640006100020000000000000000001b', // bsc - ustw-busd
      '0x33ad459e413ff93762f69a156c375adcf6196f1200020000000000000000001c', // bsc - mim-busd
      '0x8e8eb1c07f47f845c2508fe4690f3d65d7f2585e000200000000000000000015', // bsc - scUsd-busd
      '0x32296969ef14eb0c6d29669c550d4a0449130230000200000000000000000080', // Lido Metastable
      '0x1e19cf2d73a72ef1332c882f20534b6519be0276000200000000000000000112', // Rocket Pool Metastable
      '0x06df3b2bbb68adc8b0e302443692037ed9f91b42000000000000000000000012', // polygon
      '0xfeadd389a5c427952d8fdb8057d6c8ba1156cc5600020000000000000000001e', // polygon
      '0x6b15a01b5d46a5321b627bd7deef1af57bc629070000000000000000000000d4', // kovan
      '0xe08590bde837eb9b2d42aa1196469d6e08fe96ec000200000000000000000101', // kovan
      '0xb4c23af48e79f73e3a7e36c0e54eb38e1ce1755e0002000000000000000000d3', // kovan
      '0x9be7de742865d021c0e8fb9d64311b2c040c1ec1000200000000000000000012', // arbitrum
      '0x9f19a375709baf0e8e35c2c5c65aca676c4c7191000200000000000000000022', // polygon PAR/PAR,
      '0x1533a3278f3f9141d5f820a184ea4b017fce2382000000000000000000000016', // arbitrum
      '0xf38cf113d2d4f60c36cbd95af2f48a9a0167045a00000000000000000000005b', // polygon,
      '0x0d34e5dd4d8f043557145598e4e2dc286b35fd4f000000000000000000000068', // tusd polygon
      '0x386b5d43ba8b97c43d4afb4cdae7877a1b295e8a000000000000000000000020', // tusd arbitrum
      '0x5028497af0c9a54ea8c6d42a054c0341b9fc616800020000000000000000007b', // dusd polygon
      '0x7b50775383d3d6f0215a8f290f2c9e2eebbeceb20000000000000000000000fe', // Mainnet bb-a-USD
      '0x8fd162f338b770f7e879030830cde9173367f3010000000000000000000004d8', // kovan bb-a-USD,
      '0xd387dfd3a786e7caa06e6cf0c675352c7ffff30400000000000000000000063e' // kovan staBAL3
    ]
  },
  Investment: {
    AllowList: [
      '0x4fd63966879300cafafbb35d157dc5229278ed23000100000000000000000169', // kovan
      '0x37a6fc079cad790e556baedda879358e076ef1b3000100000000000000000348', // WSB Kovan
      '0xccf5575570fac94cec733a58ff91bb3d073085c70002000000000000000000af', // iROBOT mainnet
      '0xe7b1d394f3b40abeaa0b64a545dbcf89da1ecb3f00010000000000000000009a', // Techemy mainnet
      '0x3b40d7d5ae25df2561944dd68b252016c4c7b2800001000000000000000000c2' // WSB-DEFI mainnet
    ]
  },
  Factories: {
    '0xc8201dc54256c292ff8ab9b5cb6b01e1a5097037': 'oracleWeightedPool', //bsc
    '0xb7238020c331e8cdfd26db299cfd2076df812e6f': 'weightedPool', //bsc
    '0xd2eada8bffdabb9321e1512d897afd3537dbc1a3': 'stablePool', //bsc
    '0x67d27634e44793fe63c467035e31ea8635117cd4': 'stablePool', // Metastable
    '0x751dfdace1ad995ff13c927f6f761c6604532c79': 'stablePool', // Kovan
    '0x590e544e7ca956bb878f8c873e82e65550d67d2f': 'stablePool', // Kovan Metastable
    // '0xb08e16cfc07c684daa2f93c70323badb2a6cbfd2': 'managedPool', // Kovan Managed (clash with mainnet StablePhantom address)
    '0x7dfdef5f355096603419239ce743bfaf1120312b': 'weightedPool', // Arbitrum Weighted
    '0xcf0a32bbef8f064969f21f7e02328fb577382018': 'weightedPool', // Arbitrum WeightedOracle
    '0x2433477a10fc5d31b9513c638f19ee85caed53fd': 'stablePool', // Arbitrum Stable
    '0xebfd5681977e38af65a7487dc70b8221d089ccad': 'stablePool', // Arbitrum MetaStable
    '0x751a0bc0e3f75b38e01cf25bfce7ff36de1c87de': 'liquidityBootstrappingPool', // Mainnet LBP
    '0x0f3e0c4218b7b0108a3643cfe9d3ec0d4f57c54e': 'liquidityBootstrappingPool', // Mainnet LBP (zero protocol fee)
    '0x142b9666a0a3a30477b052962dda81547e7029ab': 'liquidityBootstrappingPool', // Arbitrum LBP (old)
    '0x1802953277fd955f9a254b80aa0582f193cf1d77': 'liquidityBootstrappingPool', // Arbitrum LBP (new)
    '0x48767f9f868a4a7b86a90736632f6e44c2df7fa9': 'managedPool', // Mainnet Managed
    '0x0f7bb7ce7b6ed9366f9b6b910adefe72dc538193': 'managedPool', // Polygon Managed
    '0xacd615b3705b9c880e4e7293f1030b34e57b4c1c': 'managedPool', // arbitrum managed
    '0xb08e16cfc07c684daa2f93c70323badb2a6cbfd2': 'boostedPool', // mainnet stablephantom
    '0xdae7e32adc5d490a43ccba1f0c736033f2b4efca': 'boostedPool', // arbitrum stablephantom
    '0xc128a9954e6c874ea3d62ce62b468ba073093f25': 'boostedPool', // polygon stablephantom
    '0x6c7f4d97269ece163fd08d5c2584a21e4a33934c': 'boostedPool' // kovan stablephantom
  }
};
